module.exports = __webpack_public_path__ + "static/media/user-account.62cee01c.jpg";